import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import { DirectoryEntryDialogProps } from './DirectoryEntryDialog.props';
import { toE164 } from '../../../utils/phone-format';

// Modal form for adding or editing a personal-directory contact. Phone
// number is normalised to E.164 on save so the directory list stores a
// single canonical form.

export const DirectoryEntryDialog: React.FC<DirectoryEntryDialogProps> = ({
  open,
  initial,
  onClose,
  onSave,
}) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [notes, setNotes] = useState('');
  const [phoneError, setPhoneError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setName(initial?.name ?? '');
    setPhone(initial?.phoneNumber ?? '');
    setNotes(initial?.notes ?? '');
    setPhoneError(null);
  }, [open, initial]);

  const submit = () => {
    const trimmedName = name.trim();
    if (!trimmedName) return;
    const e164 = toE164(phone);
    if (!e164) {
      setPhoneError('Enter a valid phone number');
      return;
    }
    onSave({
      name: trimmedName,
      phoneNumber: e164,
      notes: notes.trim() || null,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{initial ? 'Edit contact' : 'Add contact'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            fullWidth
            size="small"
          />
          <TextField
            label="Phone number"
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
              setPhoneError(null);
            }}
            required
            fullWidth
            size="small"
            error={Boolean(phoneError)}
            helperText={phoneError ?? '04XX XXX XXX or +61…'}
            inputProps={{ inputMode: 'tel' }}
          />
          <TextField
            label="Notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            fullWidth
            size="small"
            multiline
            minRows={2}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={submit} variant="contained" disabled={!name.trim() || !phone.trim()}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
